import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { TourProvider } from "./context/TourContext";
import Navbar from "./components/Navbar/Navbar";
import OnboardingLayer from "./components/Onboarding/OnboardingLayer";
import TourEngine from "./components/Tour/TourEngine";
import LoginPage from "./components/Auth/Login";
import RegisterPage from "./components/Auth/Register";
import ForgotPasswordPage from "./components/Auth/ForgotPassword";
import ResetPasswordPage from "./components/Auth/ResetPassword";
import Home from "./pages/Home";
import ProductsList from "./components/Products/ProductsList";
import ProductDetail from "./components/Products/ProductDetail";
import CreateProduct from "./components/Products/CreateProduct";
import EditProduct from "./components/Products/EditProduct";
import MyProducts from "./pages/MyProducts";
import OrdersList from "./components/Orders/OrdersList";
import OrderDetail from "./components/Orders/OrderDetail";
import CreateOrder from "./components/Orders/CreateOrder";
import ProfilePage from "./pages/ProfilePage";
import Messages from "./pages/Messages";
import Stats from "./pages/Stats";
import NotificationsPage from "./pages/NotificationsPage";
import "./App.css";

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <TourProvider>
        <Router>
          <div className="App">
            <Navbar />
            <OnboardingLayer />
            <TourEngine />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/products" element={<ProductsList />} />
              <Route path="/products/:productId" element={<ProductDetail />} />

              {/* Protected Routes */}
              <Route path="/products/create" element={<CreateProduct />} />
              <Route path="/products/:productId/edit" element={<EditProduct />} />
              <Route path="/my-products" element={<MyProducts />} />
              <Route path="/orders" element={<OrdersList />} />
              <Route path="/orders/:orderId" element={<OrderDetail />} />
              <Route path="/orders/create" element={<CreateOrder />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/stats" element={<Stats />} />

              {/* Fallback Route */}
              <Route
                path="*"
                element={
                  <div className="container main-content">
                    <div className="empty-state">
                      <div className="empty-state-icon">404</div>
                      <h3>Page non trouvée</h3>
                      <p>La page que vous recherchez n'existe pas.</p>
                    </div>
                  </div>
                }
              />
            </Routes>
          </div>
        </Router>
        </TourProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
